export default "__VITE_ASSET__BCcOcTNv__"